import PropTypes from 'prop-types';
import React from 'react';
import './styles.scss';

const HoverView = ({children, hoverView}) => (
  <div className="hover-view">
    {hoverView &&
    <div className="hover-helper">
      <div className="hover card depth-3">
        {hoverView}
      </div>
    </div>}
    {children}
  </div>
);

HoverView.propTypes = {
  children: PropTypes.node.isRequired,
  hoverView: PropTypes.node,
};

export default HoverView;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/HoverView/index.js